<template>
  <div id="app">
    <div class="container-fuild">
      <Header></Header>
    </div>
    <PageView/>
    <div class="container-fuild">
      <Footer></Footer>
    </div>
    <GoTop/>
  </div>
</template>

<script>
import PageView from './view/PageView.vue'

export default {
  name: 'App',
  components: {
    PageView
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.container-fuild {
  margin: 0 auto;
  width: 100%;
}
</style>
